import { useRef } from 'react';
import { OverflowTooltip } from 'components/ui/OverflowTooltip';
import {
  FirmDocumentDialogDocumentList as FirmDocumentDialogDocumentListRoot,
  FirmDocumentDialogDocumentTooltipItem,
  FirmDocumentDialogDocumentTooltipList,
} from './FirmDocumentFileActionDialogs.styles';
import { getFirmDocumentDialogFileNameItems } from './FirmDocumentFileActionDialogs.utilities';

interface FirmDocumentDialogDocumentListProps {
  fileNames?: string[];
}

const renderTooltipTitle = (fileNames: string[]) => (
  <FirmDocumentDialogDocumentTooltipList>
    {getFirmDocumentDialogFileNameItems(fileNames).map(({ fileName, key }) => (
      <FirmDocumentDialogDocumentTooltipItem key={key}>
        {fileName}
      </FirmDocumentDialogDocumentTooltipItem>
    ))}
  </FirmDocumentDialogDocumentTooltipList>
);

const FirmDocumentDialogDocumentList = ({ fileNames }: FirmDocumentDialogDocumentListProps) => {
  const documentListRef = useRef<HTMLElement | null>(null);

  if (!fileNames?.length) {
    return null;
  }

  return (
    <OverflowTooltip
      measureRef={documentListRef}
      placement="top"
      title={fileNames.length > 1 ? renderTooltipTitle(fileNames) : ''}>
      <FirmDocumentDialogDocumentListRoot ref={documentListRef}>
        {fileNames.join(', ')}
      </FirmDocumentDialogDocumentListRoot>
    </OverflowTooltip>
  );
};

export default FirmDocumentDialogDocumentList;
